
import { IManager } from '@ms/telemetry-manager/lib/Manager';
import { Facet } from '../models/Facet';

/**
 * @public
 */
export interface ITelemetryHandler {
  attach(manager: IManager): () => void;
}

/**
 * @public
 */
export const telemetryHandlersConfigurationFacet: Facet<ITelemetryHandler[]> = new Facet('telemetryHandlersConfiguration');
